import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ComponentWrapper from '../layout/ComponentWrapper';
import { Heading } from '../../util/typography';
import { charcoal, ink, pebble } from '../../util/colors';
import { createLocalScaleFunction } from '../../util/functions';

const ListWrapper = styled.div`
    // padding: ${createLocalScaleFunction(10, 320, 20, 992)} 0;
`;

const Item = styled.div`
    width: 100%;
    max-width: 824px;
    margin: 0 auto;

    display: flex;
    align-items: center;
    gap: 65px;

    padding: 40px 0;

    @media (max-width: 768px) {
        max-width: unset;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        padding: 30px 0;
    }
`;

const ItemContainer = styled.div`
    width: 100%;
    border-top: 1px solid ${pebble};

    &:first-child {
        border-top: none;
    }

    &:last-child ${Item} {
        padding-bottom: 0;
    }
`;

const IconColumn = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 60px;
        height: 60px;
        object-fit: contain;
    }

    @media (max-width: 768px) {
        flex: unset;
        text-align: center;
        width: 100%;
    }
`;

const ContentColumn = styled.div`
    flex: 1;
    min-width: 0;
`;

const ItemHeading = styled(Heading.H4)`
    margin: 0;
    color: ${ink};
`;

const SupportIconListItem = ({ iconColumn, contentMarkup, children }) => (
    <ItemContainer>
        <Item>
            <IconColumn>
                {iconColumn?.icon && (
                    <img
                        src={iconColumn.icon}
                        alt={iconColumn.alt || ''}
                    />
                )}
            </IconColumn>

            <ContentColumn>
                <ItemHeading as="h4">
                    {contentMarkup || children}
                </ItemHeading>
            </ContentColumn>
        </Item>
    </ItemContainer>
);

SupportIconListItem.propTypes = {
    iconColumn: PropTypes.object,
    contentMarkup: PropTypes.string,
    children: PropTypes.string,
};

const SupportIconList = ({ data }) => (
    <ComponentWrapper>
        <ListWrapper>
            {data.map((item, index) => (
                <SupportIconListItem
                    key={index}
                    {...item}
                />
            ))}
        </ListWrapper>
    </ComponentWrapper>
);

SupportIconList.propTypes = {
    data: PropTypes.array.isRequired,
};

export default SupportIconList;